import { Link } from "@tanstack/react-router";
import { EmptyState } from "@/components/EmptyState";
import { PageWrapper } from "@/deps/ui-library";

export function NotFoundPage() {
  return (
    // The shell's main has the padding and the width.
    <PageWrapper spacing="md" className="p-0">
      <EmptyState
        icon="FileQuestionMark"
        title="There is nothing at this address"
        description="The page may have moved, or the link is out of date."
        action={
          <Link to="/" className="text-sm text-primary font-medium">
            Back to overview
          </Link>
        }
      />
    </PageWrapper>
  );
}
